/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { IdPhotoUrlResponse } from './idPhotoUrlResponse';

export type GenericApiResponseIdPhotoUrlResponseData = IdPhotoUrlResponse | null;
